import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import style from './style';
import UiComponent from '../UiComponent';

export default class ColorPicker extends UiComponent {

  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      searchable: true,
      selectValue: '',
      clearable: true,
    };

    this.updateValue = this.updateValue.bind(this);

    this.colors = [
      { label: 'Red', value: 'rgb(255, 0, 0)', },
      { label: 'Green', value: 'rgb(0, 153, 0)', },
      { label: 'Blue', value: 'rgb(0, 0, 255)', },
      { label: 'Yellow', value: 'rgb(255, 204, 0)', },
      { label: 'Orange', value: 'rgb(255, 165, 0)', },
      { label: 'Cayan', value: 'rgb(0, 255, 255)', },
      { label: 'Pink', value: 'rgb(255, 192, 203)', },
      { label: 'Black', value: 'rgb(0, 0, 0)', },
      { label: 'Brown', value: 'rgb(165, 42, 42)' },
      { label: 'Indigo', value: 'rgb(75, 0, 130)' },
    ];
  }

  componentWillReceiveProps(props) {
    if (props.currentColor && !this.state.selectValue) {
      this.setState({
        selectValue: this.convertColorToId(props.currentColor, 'id')
      });
    }
  }

  convertColorToId(color, type) {
    const objColorsToId = {
      'rgb(255, 0, 0)': 1,
      'rgb(0, 153, 0)': 2,
      'rgb(0, 0, 255)': 3,
      'rgb(255, 204, 0)': 4,
      'rgb(255, 165, 0)': 5,
      'rgb(0, 255, 255)': 8,
      'rgb(255, 192, 203)': 9,
      'rgb(0, 0, 0)': 10,
      'rgb(165, 42, 42)': 11,
      'rgb(75, 0, 130)': 12,
    };
    if(type === 'color') {
      return objColorsToId[color];
    } else {
      for(let item in objColorsToId) {
        if (objColorsToId[item] && objColorsToId[item].toString() === color.toString()) {
          return item;
        }
      }
    }
  }

  updateValue(newValue) {
    this.setState({
      selectValue: newValue
    });

    if (this.props.field) {
      this.props.field.value = this.convertColorToId(newValue, 'color');
      this.props.handler(this.props.field.name, this.props.field);
    } else {
      this.props.handler({ job_card_color_id: this.convertColorToId(newValue, 'color') });
    }
  }


  render() {
    const options = this.colors;
    if (this.state.selectValue) {
      style.color.backgroundColor = this.state.selectValue;
    }

    return (
      <div className="row">
        <div className="col col-md-12">
          {this.getLabel()}
        </div>
        <div className="col">
          <Select
            autosize={false}
            placeholder="Pick your color"
            autofocus
            options={options}
            simpleValue
            clearable={this.state.clearable}
            name="selected-state"
            disabled={this.state.disabled || this.props.disabled}
            value={this.state.selectValue}
            onChange={this.updateValue}
            searchable={this.state.searchable}
          />
        </div>
        <div className="col" style={style.color}></div>
        <div className="col col-md-12">
          {this.getErrors()}
        </div>
      </div>
    );
  }
}

ColorPicker.propTypes = {
  handler: PropTypes.func,
  currentColor: PropTypes.string,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/СolorPicker/index.js